<div class="content-page">
  <app-aside
    messageBackground="Entre na sua conta para contratar um empréstimo consignado ou  ver contratos ativos"
  ></app-aside>
  <main class="main-page">
    <app-top-bar
      class="TelaLogin"
      [hideMenu]="true"
      TextoTopo="Identificação"
    ></app-top-bar>
    <div class="container">
      <div class="row">
        <div class="col-1"></div>
        <div class="col">
          <h1 class="TtlPrin text-center">Que bom te ver de volta!</h1>
          <h6 class="SubTtl text-center mt-4">
            Faça login para acompanhar sua solicitação ou contratar um novo
            empréstimo consignado.
          </h6>
        </div>
        <div class="col-1"></div>
      </div>
      <div class="row mt-5">
        <div class="col d-none d-md-block d-lg-block"></div>
        <div class="col col-md-6">
          <div class="TabsLogin">
            <a (click)="clickCadastro()">quero me cadastrar</a>
            <a class="active" (click)="clickLogin()"
              >já sou cliente <span class="material-icons">check</span></a
            >
          </div>
          <form
            class="FormLogin"
            [formGroup]="loginFormGroup"
            (ngSubmit)="login()"
          >
            <mat-form-field class="InputPadrao mt-5 mb-32">
              <mat-label>Qual seu CPF?</mat-label>
              <input
                type="tel"
                matInput
                required
                mask="000.000.000-00"
                formControlName="Usuario"
                maxlength="14"
                (keyup)="focusOnFieldValidation('Usuario', 'Senha')"
              />
              <mat-error>CPF inválido</mat-error>
              <mat-hint>Apenas números</mat-hint>
            </mat-form-field>

            <mat-form-field class="InputPadrao mb-32">
              <mat-label>Qual sua senha?</mat-label>
              <input
                [type]="showPassword ? 'text' : 'password'"
                type="password"
                matInput
                required
                formControlName="Senha"
              />
              <a
                (click)="showPassword = !showPassword"
                class="material-icons showPassword"
              >
                <span *ngIf="showPassword == false">remove_red_eye</span>
                <span *ngIf="showPassword"
                  ><span class="material-icons">visibility_off</span></span
                >
              </a>
            </mat-form-field>

            <div class="CheckSenha">
              <mat-checkbox class="float-start" id="LembrarAcesso"
                >Lembrar acesso</mat-checkbox
              >
              <a (click)="openDialogPassword()" class="EsqueciSenha"
                >Esqueci a senha</a
              >
            </div>

            <div class="row">
              <div class="col d-flex justify-content-center align-items-center">
                <button
                  class="Btn BtnPadrao"
                  [disabled]="!loginFormGroup.valid"
                  type="submit"
                  mat-button
                >
                  Continuar
                  <mat-icon aria-hidden="false" aria-label="east"
                    >east</mat-icon
                  >
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="col d-none d-md-block d-lg-block"></div>
      </div>
    </div>
    <app-footer></app-footer>
  </main>
</div>
